import { openBlock as e, createElementBlock as o, createElementVNode as t } from "vue";
const c = {
  xmlns: "http://www.w3.org/2000/svg",
  viewBox: "0 0 48 48"
}, n = /* @__PURE__ */ t("path", {
  "fill-rule": "evenodd",
  d: "M41.486 14.112a37.8 37.8 0 0 1 5.425 9.154c.17.443.17.934 0 1.377a37.805 37.805 0 0 1-5.425 9.154c-4.915 6.12-10.963 9.355-17.486 9.355-6.523 0-12.571-3.235-17.486-9.355a37.806 37.806 0 0 1-5.424-9.154 1.92 1.92 0 0 1 0-1.377 37.803 37.803 0 0 1 5.424-9.154c4.915-6.12 10.963-9.36 17.486-9.36 6.523 0 12.571 3.24 17.486 9.36ZM17.6 33.531a11.52 11.52 0 1 0 12.8-19.158 11.52 11.52 0 0 0-12.8 19.158Zm14.08-9.579a7.68 7.68 0 1 1-15.36 0 7.68 7.68 0 0 1 15.36 0Z",
  "clip-rule": "evenodd"
}, null, -1), r = [
  n
];
function l(d, a) {
  return e(), o("svg", c, r);
}
const i = { render: l };
export {
  i as default,
  l as render
};
//# sourceMappingURL=view-fill.svg.mjs.map
